import { Injectable } from '@angular/core';

import { APISCockpit } from 'src/service/apis-cockpit';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskStatus } from './taskstatus';

const API = '/api/construction-projects/v1/cockpit-taskstatus/';

@Injectable({ providedIn: 'root' })
export class TaskStatusService {

  taskstatus: TaskStatus = new TaskStatus();
  taskstatuslist: TaskStatus[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoTask(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.taskstatuslist = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskstatuslist.length > 0) {
        this.taskstatus = this.taskstatuslist[0];
      }
    }
    return this.taskstatus;
  }

 }
